module.exports = __webpack_public_path__ + "img/station-node-triggered.2a596b30.png";